import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../../lib/utils';

/**
 * Generated by `npx shadcn@latest add progress`, with three corrections the CLI
 * needs in this repo and will need again if it is re-run:
 *
 *   1. `cn` comes from `../../lib/utils`. The CLI resolved our `@/lib/utils`
 *      alias to the literal npm package `cn`, which is not us.
 *   2. Radix comes from `@radix-ui/react-progress`. Newer shadcn emits the
 *      `radix-ui` umbrella package; every other component here takes the
 *      individual one, and two ways of importing Radix in one folder is a
 *      second copy of Radix in the bundle.
 *   3. The file belongs in `ui/shadcn/`. The CLI wrote it to a literal `@`
 *      directory at the workspace root.
 *
 * Colours are untouched: `bg-primary` and `bg-primary/20` are the Tier 3
 * shadcn contract, so the brand arrives through the tokens rather than through
 * an edit here.
 */
function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
